import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toogleGridView } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { selectShowGridViewContext } from 'store/Workspace/selectors';
import { Wrapper, ListViewIcon, CustomButton } from './styled';

// eslint-disable-next-line import/prefer-default-export
export const ListViewButton = () => {
  const showGridView = useSelector((state) => selectShowGridViewContext(state));
  const dispatch = useDispatch();

  return showGridView && (
    <Wrapper>
      <CustomButton startIcon={ <ListViewIcon /> } onClick={ () => dispatch(toogleGridView(!showGridView)) }>List View</CustomButton>
    </Wrapper>
  );
};
